import type { SpecType } from '@local/lib';

import type { QualityAdjustmentTemplate } from './templateTypes';

import { createInitialSpecStates } from '../quality-formulas/qualityFormulaDefaults';
import { fromTemplateConfig } from './templateConfigConversion';

export const TEMPLATE_INITIAL_TEST_VALUES = { deliveredQuantity: 0, tradePrice: 0 };

export const buildInitialWorkspaceState = (template?: QualityAdjustmentTemplate) => {
  const specStates = createInitialSpecStates();
  const visibleSpecTypes: SpecType[] = template ? [template.specType] : [];

  if (template) {
    specStates[template.specType] = { ...fromTemplateConfig(template.config), collapsed: false, enabled: true };
  }

  return { specStates, visibleSpecTypes };
};
